import React from 'react';
import _ListSocial from './_ListSocial.scss';

class ListSocialRight extends React.Component {

  render() {
    return (
      <div className="list-socia">
        <p className='title-social'>CONNECT</p>
        <ul className='list-social'>
          <li className='item'><a className='item-link' href='https://www.facebook.com/kontumtrade.gov.vn/' target='blank'><i className='fa fa-facebook-f'></i></a></li>
          <li className='item'><a className='item-link' href='#' target='blank'><i className='fa fa-twitter'></i></a></li>
          <li className='item'><a className='item-link' href='#' target='blank'><i className='fa fa-google-plus'></i></a></li>
          <li className='item'><a className='item-link' href='#' target='blank'><i className='fa fa-youtube'></i></a></li>
          <li className='item'><a className='item-link' href='#' target='blank'><i className='fa fa-instagram'></i></a></li>
          <li className='item'><a className='item-link' href='#' target='blank'><i className='fa fa-pinterest-p'></i></a></li>
        </ul>
        <a target="_blank" href="http://online.gov.vn/HomePage/WebsiteDisplay.aspx?DocId=52806"><img alt="Đã đăng ký Bộ Công Thương" title="" src={require('assets/images/footer/logoCCDV.jpg')} height="100"/></a>
      </div>
    );
  }
}
export default ListSocialRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/ListSocialRight.jsx